import { Component, input, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { firstValueFrom, Observable } from 'rxjs';
import { share, takeUntil } from 'rxjs/operators';
import { ClubService } from 'src/app/core/firebase/club.service';
import { FireSubService } from 'src/app/core/firebase/fireSub.service';
import { ProfileService } from 'src/app/core/firebase/profile.service';
import { fadeIn } from '../../animations/animations';
import { SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoConfirmSettings } from 'src/app/sopo-popup/interfaces/confirm';

@Component({
    selector: 'app-notifications-toggle',
    templateUrl: './notifications-toggle.component.html',
    styleUrls: ['./notifications-toggle.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class NotificationsToggleComponent implements OnInit {
    @Input() clubID?: string;
    isBell = input<boolean>(true);
    isAllowedClubNotifications$: Observable<boolean>;
    clubId: string = '';
    userId: string = '';
    label: string;

    constructor(
    private profileService: ProfileService,
    private clubService: ClubService,
    private fireSubService: FireSubService,
    private route: ActivatedRoute,
    private popoverController: PopoverController,
    private sopoPopupService: SopoPopupService,
    ) { }

    ngOnInit() {
        firstValueFrom(this.profileService.getMyUserId()).then(userId => {
            this.userId = userId;
            this.clubId = this.clubID ? this.clubID : this.route.snapshot.params['id'];
            this.isAllowedClubNotifications$ = this.clubService.isUserAllowedForClubChatNotifications(this.userId, this.clubId)
            .pipe(
                takeUntil(this.fireSubService.unsubscriber),
                share(),
            );
        });
    }

    setChatNotification(to: boolean) {
        if (this.label) this.popoverController.dismiss();
        const options: SopoConfirmSettings = {
            data: {
                header: 'Club chat notifications',
                body: to ? 'Do you want to disable club chat notifications?' : 'Do you want to enable club chat notifications?',
                sCss: ['sopo-popup-red-background'],
            }
        }

        this.sopoPopupService.promptForConfirmation('app', options).then((confirmed) =>{
            if (confirmed) {
                this.clubService.setChatNotificationRight(this.userId, this.clubId, to);
            }
        });
    }

    getNotificationOnImgUrl(): string {
        if (this.isBell()) return 'assets/icon/notification-bell.png';
        return '/assets/img/chat_notification_on.png';
    }

    getNotificationOffImgUrl(): string {
        if (this.isBell()) return 'assets/icon/notification-bell-muted.png';
        return '/assets/img/chat_notification_off.png';
    }
}